import Model from '@/store/model';
import ModelError from '../model_error';

class UserAction extends Model {
  map(json) {
    super.map(json);
    if (json.errors !== undefined && json.errors !== null) {
      this.mapArray('errors', json.errors, ModelError);
    }
  }

  static userActionTypes = {
    userActionContentOpen: 1,
    userActionAppOpen: 2,
    userActionTimeInapp: 3,
    userActionStarredContent: 4,
    userActionTestQuit: 5,
    userActionAppInvite: 6,
    userActionAppInvite_sent: 7,
    userActionBadgeBestOfMonth: 8,
    userActionBadgeBestOfMonthFriends: 9,
    userActionBadgeBestOfWeek: 10,
    userActionBadgeBestOfWeekFriends: 11,
    userActionDailyLessonOpen: 12,
    userActionOpenShop: 13,
    userActionOpenProfile: 14,
    userActionOpenSettings: 15,
    userActionPurchaseCancel: 17,
    userActionSeeCatalog: 18,
    userActionCloseLoginRecommendation: 19,
    userActionReadCheckWordBuilder: 20,
    userActionSawThisIslandLevel: 21,
    userActionSeeMyEvents: 22,
    userActionSeeFriendsEvents: 23,
    userActionSeeLastWeekPlacement: 24,
    userActionSeeWeeklyEnglish: 25,
    userActionOpenProFunctionPopup: 26,
  };
}
export default UserAction;
